// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"9dd5e9a1","173":"5cd18c8d","237":"758508a5","256":"ab87fc72","324":"3cde971d","385":"95bfbb9f","408":"905f8488","758":"415cca22","766":"9dd5e9a1"}[chunkId] + ".chunk.css";
};